import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TeamMember } from '../../../models/team-member';

@Component({
  selector: 'app-team-list-desktop',
  standalone: false,
  templateUrl: './team-list-desktop.component.html',
  styleUrls: ['./team-list-desktop.component.scss'],
})
export class TeamListDesktopComponent {
  @Input() public teamMembers: TeamMember[] = [];
  @Output() public loadHistoric = new EventEmitter<string>();
}
